/*
 * @Author: your name
 * @Date: 2020-08-11 21:01:30
 * @LastEditTime: 2022-10-27 14:46:55
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/plugins/vant.js
 */
import Vue from 'vue'
import componentLoader from '@/utils/componentLoader'

// 核心组件 - 同步加载（应用启动时必需）
import {
  Button,
  Icon,
  Loading,
  Popup,
  Overlay,
  Tab,
  Tabs,
  Stepper,
  Cell,
  CellGroup,
  Locale,
  Lazyload
} from 'vant'
import enUS from 'vant/lib/locale/lang/en-US'

// 设置语言
Locale.use('en-US', enUS)

// 注册核心组件
Vue
  .use(Button)
  .use(Icon)
  .use(Loading)
  .use(Popup)
  .use(Overlay)
  .use(Tab)
  .use(Tabs)
  .use(Stepper)
  .use(Cell)
  .use(CellGroup)
  .use(Lazyload, {
    loading: require('@/assets/defaultProductsImg/Food.jpg'),
    lazyComponent: true,
    observer: true // 使用 Intersection Observer
  })

// 注册核心组件已加载
componentLoader.loadedComponents.add('vant-base')

// 延迟加载的组件
const loadVantComponents = () => {
  const promise = import('vant').then(({
    ActionSheet,
    Form,
    Field,
    Collapse,
    CollapseItem,
    RadioGroup,
    Radio,
    CheckboxGroup,
    DatetimePicker,
    Picker,
    Checkbox,
    List,
    Notify
  }) => {
    Vue
      .use(ActionSheet)
      .use(Form)
      .use(Picker)
      .use(DatetimePicker)
      .use(Notify)
      .use(Field)
      .use(Collapse)
      .use(CollapseItem)
      .use(RadioGroup)
      .use(Radio)
      .use(CheckboxGroup)
      .use(Checkbox)
      .use(List)

    console.log('Vant form components loaded')
  })

  // 注册加载承诺
  componentLoader.registerLoadingPromise('vant-form', promise)
  return promise
}

// 根据当前路由决定是否立即加载
const shouldLoadImmediately = () => {
  const path = window.location.pathname
  return path.includes('cart') ||
         path.includes('payment') ||
         path.includes('checkout') ||
         path.includes('pay')
}

// 应用启动后加载
if (shouldLoadImmediately()) {
  // 关键页面立即加载
  loadVantComponents().catch(error => {
    console.error('Vant components load fail:', error)
  })
} else {
  // 非关键页面延迟加载
  setTimeout(() => {
    loadVantComponents().catch(error => {
      console.error('Vant components load fail:', error)
    })
  }, 500)
}
